@if (!items?.length) {
    <div class="w-100 radius-16 min-height"
         [attr.data-testid]="testId"
         [class.bc-primary-gray-50]="backgroundColor === 'dark'"
         [class.bc-mono-white]="backgroundColor === 'light'"
         [class.no-button]="!clickListener.observed || !buttonLabel"
         [class.small]="isSmall"
         fxLayout="column"
         fxLayoutAlign="center center"
         fxFlex>
        @if (!spinnerIsShown()) {
            <ui-kit-svg class="i-80" [name]="icon"></ui-kit-svg>
            <div class="h3-semi-bold mt-16 c-primary-gray-900 text-center" ngClass.mobile="h3-semi-bold"
                 [attr.data-testid]="testId ? testId + '-message' : null">
                {{ title | translate: additionalParams }}
            </div>
            @if (subtitle) {
                <div class="t3 mt-16 c-primary-gray-900 text-center" [innerHtml]="subtitle | translate: additionalParams"></div>
            }
            @if (clickListener.observed && buttonLabel) {
                <ui-kit-button type="primary"
                               [testId]="testId ? testId + '-button' : null"
                               [label]="buttonLabel | translate"
                               class="mt-56"
                               (clickListener)="clickListener.emit()"/>
            }
        }
        @if (spinnerIsShown()) {
            <ngx-spinner
                size="default"
                color="#045B4A"
                type="ball-fussion"
                [fullScreen]="false"/>
        }
    </div>
}
